  import { initializeApp } from "firebase/app";
  import { getFirestore } from "firebase/firestore";
  import { getStorage } from "firebase/storage";

  const firebaseConfig = {
    apiKey: "AIzaSyA7keYvHwbQh1-A0OgoDXEgPbslAtFDyaE",
    authDomain: "crossmintonboard.firebaseapp.com",
    projectId: "crossmintonboard",
    storageBucket: "crossmintonboard.firebasestorage.app",
    messagingSenderId: "1040175541648",
    appId: "1:1040175541648:web:c2cd0edd1edb2aca0a1715",
  };
  const app = initializeApp(firebaseConfig);

  export const storage = getStorage(app);

  // Firestore instance
  export const db = getFirestore(app);
